import { HttpErrorResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "@api/services/api.service";
import { ICenter } from "@shared/models/center";
import { catchError, EMPTY, Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class CentersDataService {
    private readonly router = inject(Router);
    private readonly apiService = inject(ApiService);

    public getHealthCenters(): Observable<ICenter[]> {
        const endpoint = "api/centers";
        return this.apiService.get<ICenter[]>(endpoint).pipe(
            catchError((err) => {
                if (err instanceof HttpErrorResponse && (err.status === 403 || err.status === 401)) {
                    this.router.navigate(["/unauthorized"]);
                } else {
                    this.router.navigate(["/unexpected-error"]);
                }

                // NOTE - BS - return EMPTY instead of [] as downstream consumers need to differentiate
                //             between an error response and a valid empty response
                return EMPTY;
            }),
        );
    }
}
